export default "__VITE_ASSET__DdT8gLzN__"